var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"type-well-button"},[_c('button',{class:{ disabledButton: _vm.state.isValid },attrs:{"disabled":!_vm.state.isValid},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.state.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }